import { createFileRoute } from '@tanstack/react-router';
import { ConnectionsPage } from '../components/community/ConnectionsPage';

export const Route = createFileRoute('/community/connections')({
  component: ConnectionsPage,
});
